import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { SettingsRoutingModule } from './settings-routing.module';
import { SettingsComponent } from './settings.component';
import { ProfileInformationComponent } from './profile-information/profile-information.component';
import { CountryAffiliationComponent } from './country-affiliation/country-affiliation.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import { FormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { ConfirmationDialogComponent } from './country-affiliation/confirmation-dialog/confirmation-dialog.component';
//import { AddCountryComponent } from './country-affiliation/add-country/add-country.component';
//import { ChangePasswordDialogComponent } from './profile-information/change-password-dialog/change-password-dialog.component';


import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { UserService } from '../../core/services/user.service';
import { MatDialogModule } from '@angular/material/dialog';
import { FilterPipe } from 'src/app/filter.pipe';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // If using native JS Date
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatMenuModule } from '@angular/material/menu';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { InvoicePdfViewerComponent } from "src/app/invoice-pdf-viewer/invoice-pdf-viewer.component";
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    ProfileInformationComponent,
    CountryAffiliationComponent,
    SubscriptionComponent,
    ConfirmationDialogComponent,
    // AddCountryComponent,
    // ChangePasswordDialogComponent
  ],
  imports: [
    CommonModule,
    SettingsRoutingModule,
    FormsModule,
    SharedModule,
    MatTableModule,
    MatTabsModule,
    MatMenuModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    RouterModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatAutocompleteModule,
    BsDatepickerModule,
    InvoicePdfViewerComponent
]
})
export class SettingsModule { }
